<template>
  <Transition
    enter-active-class=" transition-all ease-in-out duration-500 delay-1000"
    enter-from-class="opacity-0 translate-x-20"
    enter-to-class="opacity-100 translate-x-0"
    leave-active-class="transition-all ease-in duration-300"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="pointer-events-auto mb-10 w-full max-w-lg rounded-lg bg-white shadow-xl ring-1 ring-gray-400 focus:outline-none md:mb-0"
      :class="allowOverflow ? '' : 'overflow-hidden'"
    >
      <slot />
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps({
  show: { type: Boolean, default: false },
  allowOverflow: {
    type: Boolean,
    default: false,
  },
});
</script>
